"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConsentStruct = exports.UserConsentCopyStruct = exports.UserConsentPreferenceStruct = exports.UserConsentPreferenceInputStruct = void 0;
const superstruct_1 = require("superstruct");
exports.UserConsentPreferenceInputStruct = (0, superstruct_1.object)({
    consentId: (0, superstruct_1.string)(),
    optIn: (0, superstruct_1.boolean)(),
});
exports.UserConsentPreferenceStruct = (0, superstruct_1.object)({
    consentId: (0, superstruct_1.string)(),
    optIn: (0, superstruct_1.nullable)((0, superstruct_1.boolean)()),
    lastUpdated: (0, superstruct_1.nullable)((0, superstruct_1.number)()),
});
exports.UserConsentCopyStruct = (0, superstruct_1.object)({
    country: (0, superstruct_1.string)(),
    locale: (0, superstruct_1.string)(),
    title: (0, superstruct_1.string)(),
    subtitle: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    richText: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    okButtonText: (0, superstruct_1.string)(),
    selectAllText: (0, superstruct_1.string)(),
    copies: (0, superstruct_1.array)((0, superstruct_1.object)({
        consentId: (0, superstruct_1.string)(),
        order: (0, superstruct_1.number)(),
        consentName: (0, superstruct_1.string)(),
        consentText: (0, superstruct_1.string)(),
        consentDesc: (0, superstruct_1.nullable)((0, superstruct_1.string)()),
        display: (0, superstruct_1.boolean)(),
        enabled: (0, superstruct_1.boolean)(),
        required: (0, superstruct_1.boolean)(),
        prechecked: (0, superstruct_1.boolean)(),
    })),
});
exports.UserConsentStruct = (0, superstruct_1.object)({
    userId: (0, superstruct_1.string)(),
    userActionRequired: (0, superstruct_1.boolean)(),
    preferences: (0, superstruct_1.nonempty)((0, superstruct_1.array)(exports.UserConsentPreferenceStruct)),
    consentCopy: exports.UserConsentCopyStruct,
});
